/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Shop_Tier_Discount_Input_LabelInputs */

const vi_shop_tier_discount_input_label = /** @type {(inputs: Shop_Tier_Discount_Input_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ưu đãi (%) — 0 đến ${i?.max}`)
};

/**

* @param {Shop_Tier_Discount_Input_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_tier_discount_input_label = /** @type {((inputs: Shop_Tier_Discount_Input_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tier_Discount_Input_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_tier_discount_input_label(inputs)
});